/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateLicencaFormDto } from '../models/create-licenca-form-dto';
import { LicencaCriteriaDto } from '../models/licenca-criteria-dto';
import { LicencaDto } from '../models/licenca-dto';
import { LicencaPageDto } from '../models/licenca-page-dto';
import { UpdateLicencaFormDto } from '../models/update-licenca-form-dto';


/**
 * Licencas
 */
@Injectable({
  providedIn: 'root',
})
export class LicencasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getLicencas
   */
  static readonly GetLicencasPath = '/licencas';

  /**
   * Pesquisar licencas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLicencas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLicencas$Response(params?: {
    criteria?: LicencaCriteriaDto;
  }): Observable<StrictHttpResponse<LicencaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.GetLicencasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaPageDto>;
      })
    );
  }

  /**
   * Pesquisar licencas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLicencas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLicencas(params?: {
    criteria?: LicencaCriteriaDto;
  }): Observable<LicencaPageDto> {

    return this.getLicencas$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaPageDto>) => r.body as LicencaPageDto)
    );
  }

  /**
   * Path part for operation createLicenca
   */
  static readonly CreateLicencaPath = '/licencas';

  /**
   * Criar licença.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLicenca()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLicenca$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateLicencaFormDto
  }): Observable<StrictHttpResponse<LicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.CreateLicencaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaDto>;
      })
    );
  }

  /**
   * Criar licença.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createLicenca$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLicenca(params?: {

    /**
     * apiRequest
     */
    body?: CreateLicencaFormDto
  }): Observable<LicencaDto> {

    return this.createLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaDto>) => r.body as LicencaDto)
    );
  }

  /**
   * Path part for operation getLicenca
   */
  static readonly GetLicencaPath = '/licencas/{id}';

  /**
   * Obter licença.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLicenca()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLicenca$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<LicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.GetLicencaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaDto>;
      })
    );
  }

  /**
   * Obter licença.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLicenca$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLicenca(params: {
    id: number;
  }): Observable<LicencaDto> {

    return this.getLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaDto>) => r.body as LicencaDto)
    );
  }

  /**
   * Path part for operation updateLicenca
   */
  static readonly UpdateLicencaPath = '/licencas/{id}';

  /**
   * Atualizar licença.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLicenca()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLicenca$Response(params: {
    id: number;
    body?: UpdateLicencaFormDto
  }): Observable<StrictHttpResponse<LicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.UpdateLicencaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaDto>;
      })
    );
  }

  /**
   * Atualizar licença.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateLicenca$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLicenca(params: {
    id: number;
    body?: UpdateLicencaFormDto
  }): Observable<LicencaDto> {

    return this.updateLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaDto>) => r.body as LicencaDto)
    );
  }

  /**
   * Path part for operation ativarLicenca
   */
  static readonly AtivarLicencaPath = '/licencas/{id}/ativar';

  /**
   * Ativar licença.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarLicenca()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarLicenca$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<LicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.AtivarLicencaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaDto>;
      })
    );
  }

  /**
   * Ativar licença.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarLicenca$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarLicenca(params: {
    id: number;
  }): Observable<LicencaDto> {

    return this.ativarLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaDto>) => r.body as LicencaDto)
    );
  }

  /**
   * Path part for operation desativarLicenca
   */
  static readonly DesativarLicencaPath = '/licencas/{id}/desativar';

  /**
   * Desativar Licença.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarLicenca()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarLicenca$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<LicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LicencasService.DesativarLicencaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LicencaDto>;
      })
    );
  }

  /**
   * Desativar Licença.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarLicenca$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarLicenca(params: {
    id: number;
  }): Observable<LicencaDto> {

    return this.desativarLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<LicencaDto>) => r.body as LicencaDto)
    );
  }

}
